/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInventoryItemRequest } from '../../models/create-inventory-item-request';
import { InventoryItemDto } from '../../models/inventory-item-dto';

export interface CreateInventoryItem$Params {
      body: CreateInventoryItemRequest
}

export function createInventoryItem(http: HttpClient, rootUrl: string, params: CreateInventoryItem$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryItemDto>> {
  const rb = new RequestBuilder(rootUrl, createInventoryItem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryItemDto>;
    })
  );
}

createInventoryItem.PATH = '/v0/inventoryItems';
